import React from 'react';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';
import { Modal } from 'react-bootstrap';
import ValueReference from './value-reference';
import ValueSelector from './value-selector';
import Flow from '../../components/flow';
import ValueSource from '../../sources/value';
import '../../../css/values.less';

class ValueReferenceSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = { isValueSelectorOpen: false };

        this.openValueSelector = this.openValueSelector.bind(this);
        this.closeValueSelector = this.closeValueSelector.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onNewValue = this.onNewValue.bind(this);
        this.openNewValue = this.openNewValue.bind(this);
        this.closeNewValue = this.closeNewValue.bind(this);
        this.removeValue = this.removeValue.bind(this);
        this.editValue = this.editValue.bind(this);
        this.editSelectedValue = this.editSelectedValue.bind(this);
        this.getNewValueInputs = this.getNewValueInputs.bind(this);
    }

    openValueSelector() {
        this.setState({ isValueSelectorOpen: true });
    }

    closeValueSelector() {
        this.setState({ isValueSelectorOpen: false });
    }

    onChange(value, id) {
        const selectedItem = JSON.parse(JSON.stringify(value));
        selectedItem.isSelected = true;

        this.props.onChange(selectedItem, this.props.id);
        this.setState({ isValueSelectorOpen: false });
    }

    onNewValue(callback, response) {
        if (response && response.outputs) {
            const command = manywho.utils.getObjectDataProperty(response.outputs, 'Command').contentValue;

            if (manywho.utils.isEqual(command, 'save', true)) {
                const newValue = manywho.utils.getObjectDataProperty(response.outputs, 'ValueElementIdReference');
                const id = manywho.utils.getObjectDataProperty(newValue.objectData[0].properties, 'Id').contentValue;

                if (!manywho.utils.isNullOrWhitespace(this.props.flowId))
                    ValueSource.import(id, this.props.flowId, this.props.tenantId, this.props.authenticationToken);

                this.onChange(newValue.objectData[0], null);
            }

            this.setState({ isNewValueOpen: false });
        }
    }

    openNewValue(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.isEnabled === false)
            return;

        this.setState({ isNewValueOpen: true, isValueSelectorOpen: false, editExisting: false });
    }

    closeNewValue() {
        this.setState({ isNewValueOpen: false });
    }

    removeValue(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.isEnabled === false)
            return;

        this.props.onChange(null, this.props.id);
    }

    editSelectedValue(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.isEnabled === false)
            return;

        this.setState({ isNewValueOpen: true, isValueSelectorOpen: false, editExisting: true });
    }

    editValue(value) {
        this.setState({ isNewValueOpen: true, isValueSelectorOpen: false, editExisting: true });
        this.onChange(value);
    }

    getNewValueInputs(objectDataRequest) {
        const inputs = [];

        if (objectDataRequest
            && objectDataRequest.listFilter
            && objectDataRequest.listFilter.where
            && objectDataRequest.listFilter.where.length > 0) {

            const contentType = objectDataRequest.listFilter.where.find(where => manywho.utils.isEqual(where.columnName, 'ContentType', true));
            if (contentType && contentType.value)
                inputs.push({ 'New Value ContentType': contentType.value });

            const typeElementId = objectDataRequest.listFilter.where.find(where => manywho.utils.isEqual(where.columnName, 'TypeElementId', true));
            if (
                typeElementId
                && contentType
                && typeElementId.value
                && (manywho.utils.isEqual(contentType.value, manywho.component.contentTypes.object, true) || manywho.utils.isEqual(contentType.value, manywho.component.contentTypes.list, true)))
                inputs.push({ 'New Value TypeElementId': typeElementId.value });
        }

        return inputs;
    }

    componentDidMount() {
        let element = findDOMNode(this);
        while ((element = element.parentElement) && !element.classList.contains(this.props.containerClassName || 'flow'));
        this.container = element;
    }

    render() {
        let valueReference = null;

        if (this.props.value && !manywho.utils.isPlaceholderObjectData([this.props.value]))
            valueReference = <div className="value-reference-value form-group value-selected" onClick={this.openValueSelector}>
                <ValueReference reference={this.props.value} />
                <button className="btn btn-default btn-link" onClick={this.openValueSelector}>Select</button>
                <button className="btn btn-default btn-link" onClick={this.editSelectedValue}>Edit</button>
                <button className="btn btn-default btn-link" onClick={this.removeValue}>Remove</button>
            </div>
        else
            valueReference = <button className="btn btn-primary select-or-new-value" onClick={this.openValueSelector}>Select or create a new Value</button>

        let label = null;
        if (!manywho.utils.isNullOrWhitespace(this.props.label) || this.props.isRequired)
            label = <label>
                {this.props.label}
                {(this.props.isRequired) ? <span className="input-required"> *</span> : null}
            </label>

        let newValueFlow = null;
        if (this.state.isNewValueOpen) {
            let inputs = [
                { 'FlowId': '' },
                {'Input TenantId': this.props.tenantId },
                { 'Input AuthenticationToken': this.props.authenticationToken }
            ];

            if (this.props.value && this.state.editExisting)
                inputs.push({ 'Id': manywho.utils.getObjectDataProperty(this.props.value.properties, 'Id').contentValue });
            else
                inputs = inputs.concat(this.getNewValueInputs(this.props.objectDataRequest));

            if (!manywho.utils.isNullOrWhitespace(this.props.name))
                inputs.push({ 'New Value Name': this.props.name });

            newValueFlow = <Flow tenantId={manywho.settings.global('adminTenantId')} key="new-value-flow" flowName="Value Manager" inputs={inputs} component="main" callbacks={[{execute: this.onNewValue, type: 'done' }]} />
        }

        let className = 'value-reference-selector';
        if (this.props.isValid === false)
            className += ' has-error';

        if (this.props.isEnabled === false)
            className += ' disabled';

        return <div className={className} id={this.props.id}>
            {label}
            {valueReference}
            {!this.props.isValid ? <span className="help-block">{this.props.validationMessage}</span> : null}
            <Modal className="value-selector-dialog-container" enforceFocus={false} container={this.container} show={this.state.isValueSelectorOpen} onHide={this.closeValueSelector} backdrop={true} bsSize="large" dialogClassName="value-selector-dialog">
                <Modal.Body>
                    <ValueSelector reference={this.props.value} objectDataRequest={this.props.objectDataRequest} onChange={this.onChange} onEdit={this.editValue} flowId={this.props.flowId} isVisible={this.state.isValueSelectorOpen} onCancel={this.closeValueSelector} onNew={this.openNewValue} />
                </Modal.Body>
            </Modal>
            <Modal className="value-selector-dialog-container" container={this.container} enforceFocus={false} show={this.state.isNewValueOpen} onHide={this.closeNewValue} backdrop={true} bsSize="large" dialogClassName="value-selector-dialog">
                <Modal.Body>
                    {newValueFlow}
                </Modal.Body>
            </Modal>
        </div>
    }

}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
)(ValueReferenceSelector);
